export default __webpack_public_path__ + "static/media/life02.ff1c7f58.png";